import {
  CHANGE_LOADING_TRUE,
  CHANGE_LOADING_FALSE,
} from '../actions/loadingActions';

const initialState = {
  loading: false,
  loadingQuantity: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOADING_TRUE:
      return {
        ...state,
        loadingQuantity: state.loadingQuantity + 1,
        loading: state.loadingQuantity > 0,
      };
    case CHANGE_LOADING_FALSE:
      return {
        ...state,
        loadingQuantity:
          state.loadingQuantity <= 0 ? 0 : state.loadingQuantity - 1,
        loading: state.loadingQuantity > 0,
      };
    default:
      return state;
  }
}
